var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{clip-path:url(#clip-path-3);}.cls-5{clip-path:url(#clip-path-4);}.cls-6{clip-path:url(#clip-path-5);}.cls-7{clip-path:url(#clip-path-6);}.cls-8{fill:#021722;}.cls-21,.cls-9{opacity:0.4;}.cls-10{opacity:1;}.cls-10,.cls-12,.cls-21{isolation:isolate;}.cls-11{fill:#264152;}.cls-12{opacity:0.7;}.cls-13{clip-path:url(#clip-path-8);}.cls-14{clip-path:url(#clip-path-9);}.cls-15{clip-path:url(#clip-path-10);}.cls-16{clip-path:url(#clip-path-11);}.cls-17{clip-path:url(#clip-path-12);}.cls-18{clip-path:url(#clip-path-13);}.cls-19{clip-path:url(#clip-path-14);}.cls-20{clip-path:url(#clip-path-16);}.cls-22{fill:#10596f;}.cls-23{clip-path:url(#clip-path-17);}.cls-24{clip-path:url(#clip-path-18);}.cls-25{clip-path:url(#clip-path-19);}.cls-26{clip-path:url(#clip-path-20);}.cls-27{clip-path:url(#clip-path-21);}.cls-28{clip-path:url(#clip-path-22);}.cls-29{clip-path:url(#clip-path-24);}.cls-30{clip-path:url(#clip-path-25);}.cls-31{clip-path:url(#clip-path-26);}.cls-32{clip-path:url(#clip-path-27);}.cls-33{clip-path:url(#clip-path-28);}.cls-34{clip-path:url(#clip-path-29);}.cls-35{clip-path:url(#clip-path-30);}.cls-36{clip-path:url(#clip-path-32);}.cls-37{clip-path:url(#clip-path-33);}.cls-38{clip-path:url(#clip-path-34);}.cls-39{clip-path:url(#clip-path-35);}.cls-40{clip-path:url(#clip-path-36);}.cls-41{clip-path:url(#clip-path-37);}.cls-42{clip-path:url(#clip-path-38);}.cls-43{clip-path:url(#clip-path-40);}.cls-44{clip-path:url(#clip-path-41);}.cls-45{clip-path:url(#clip-path-42);}.cls-46{clip-path:url(#clip-path-43);}.cls-47{clip-path:url(#clip-path-44);}.cls-48{clip-path:url(#clip-path-45);}.cls-49{clip-path:url(#clip-path-46);}.cls-50{clip-path:url(#clip-path-48);}.cls-51{clip-path:url(#clip-path-49);}.cls-52{clip-path:url(#clip-path-50);}.cls-53{clip-path:url(#clip-path-51);}.cls-54{clip-path:url(#clip-path-52);}.cls-55{clip-path:url(#clip-path-53);}.cls-56{clip-path:url(#clip-path-54);}.cls-57{clip-path:url(#clip-path-56);}.cls-58{fill:#147086;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.61,112.82v12.05c-6-1.56-9.79-3.83-9.79-6.24V108C90.44,110,93.9,111.62,98.61,112.82Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.1,114.7v12.07a70.59,70.59,0,0,1-11.47-1.64v-12A71.67,71.67,0,0,0,111.1,114.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.74,114.67v12.07a90,90,0,0,1-11.61.09V114.76c1.65.09,3.35.13,5.09.13C119.47,114.89,121.65,114.82,123.74,114.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.77,114.59A67.28,67.28,0,0,0,135.23,113v12a65.79,65.79,0,0,1-10.46,1.63Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.61,108v10.61c0,2.26-3.47,4.53-9.34,6.13V112.71C140.75,111.52,144.05,109.89,145.61,108Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.59,105a1.84,1.84,0,0,1,0,.52V105Zm-58.8,0v.52a3.05,3.05,0,0,1,0-.52Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 117.23,
    cy: 105.53,
    rx: 23.9,
    ry: 6.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.59,107.36v12c-6-1.57-9.78-3.84-9.78-6.25V102.55C32.42,104.49,35.89,106.16,40.59,107.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.09,109.23V121.3a70.44,70.44,0,0,1-11.47-1.64v-12A70.39,70.39,0,0,0,53.09,109.23Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.73,109.2v12.08a90,90,0,0,1-11.61.08V109.29c1.65.1,3.35.14,5.09.14C61.46,109.43,63.64,109.36,65.73,109.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.76,109.13a68.52,68.52,0,0,0,10.46-1.62v12a66.17,66.17,0,0,1-10.46,1.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.6,102.55v10.61c0,2.27-3.48,4.54-9.34,6.14V107.24C82.74,106.05,86,104.43,87.6,102.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.58,99.54a2.21,2.21,0,0,1,0,.51v-.51Zm-58.8,0v.51a2.21,2.21,0,0,1,0-.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 59.03,
    cy: 100.13,
    rx: 24.28,
    ry: 6.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.46,91.09v12c-6-1.56-9.79-3.84-9.79-6.25V86.29C24.29,88.22,27.76,89.89,32.46,91.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,93V105a70.42,70.42,0,0,1-11.47-1.63V91.35A70.39,70.39,0,0,0,45,93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.6,92.93V105a90,90,0,0,1-11.61.08V93c1.64.09,3.34.13,5.08.13C53.32,93.16,55.5,93.09,57.6,92.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.62,92.86a69.69,69.69,0,0,0,10.47-1.61v12a65,65,0,0,1-10.47,1.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.47,86.29V96.9c0,2.26-3.48,4.53-9.35,6.13V91C74.6,89.78,77.9,88.16,79.47,86.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.45,83.27a3,3,0,0,1,0,.52v-.52Zm-58.81,0v.52a2.24,2.24,0,0,1,.06-.52Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 51.32,
    cy: 83.95,
    rx: 23.51,
    ry: 6.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.1,91.09v12c-6-1.56-9.78-3.84-9.78-6.25V86.29C81.93,88.22,85.4,89.89,90.1,91.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.6,93V105a70.42,70.42,0,0,1-11.47-1.63V91.35A70.39,70.39,0,0,0,102.6,93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.24,92.93V105a90,90,0,0,1-11.61.08V93c1.65.09,3.34.13,5.08.13C111,93.16,113.15,93.09,115.24,92.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.27,92.86a69.75,69.75,0,0,0,10.46-1.61v12a65,65,0,0,1-10.46,1.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.11,86.29V96.9c0,2.26-3.48,4.53-9.34,6.13V91C132.24,89.78,135.55,88.16,137.11,86.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.09,83.27a2.24,2.24,0,0,1,0,.52v-.52Zm-58.8,0v.52a1.8,1.8,0,0,1,0-.52Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 108.75,
    cy: 83.95,
    rx: 23.9,
    ry: 6.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.58,73.14v12c-6-1.56-9.79-3.83-9.79-6.24V68.33C39.41,70.26,42.88,71.93,47.58,73.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.08,75V87.08a70.44,70.44,0,0,1-11.47-1.64v-12A71.51,71.51,0,0,0,60.08,75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.72,75V87.06a91.81,91.81,0,0,1-11.61.08V75.07c1.64.09,3.34.13,5.08.13C68.44,75.21,70.62,75.13,72.72,75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.74,74.91a68.45,68.45,0,0,0,10.47-1.62v12A67.28,67.28,0,0,1,73.74,87Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.59,68.33V78.94c0,2.26-3.48,4.54-9.35,6.13V73C89.72,71.83,93,70.2,94.59,68.33Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.57,65.32a2.84,2.84,0,0,1,.05.51v-.51Zm-58.81,0v.51a2.16,2.16,0,0,1,.06-.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 66.35,
    cy: 66.22,
    rx: 23.9,
    ry: 6.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.31,75.45v12c-6-1.57-9.79-3.84-9.79-6.25V70.64C94.14,72.58,97.61,74.24,102.31,75.45Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.81,77.32V89.39a70.56,70.56,0,0,1-11.48-1.64v-12A72.76,72.76,0,0,0,114.81,77.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.44,77.29V89.37a89.81,89.81,0,0,1-11.6.08V77.38c1.64.1,3.34.14,5.08.14C123.17,77.52,125.35,77.45,127.44,77.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.47,77.22a68.32,68.32,0,0,0,10.46-1.62V87.65a65.81,65.81,0,0,1-10.46,1.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.31,70.64V81.25c0,2.26-3.47,4.54-9.34,6.13v-12C144.45,74.14,147.75,72.52,149.31,70.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.29,67.63a1.77,1.77,0,0,1,.05.51v-.51Zm-58.8,0v.51a2.94,2.94,0,0,1,.05-.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 121.08,
    cy: 68.53,
    rx: 23.9,
    ry: 6.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.42,57.72v12c-6-1.57-9.78-3.84-9.78-6.25V52.91C60.25,54.85,63.72,56.52,68.42,57.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.92,59.59V71.66A70.44,70.44,0,0,1,69.45,70V58A70.39,70.39,0,0,0,80.92,59.59Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.56,59.56V71.64A90,90,0,0,1,82,71.72V59.65c1.65.1,3.34.14,5.08.14C89.28,59.79,91.47,59.72,93.56,59.56Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.58,59.49a68.45,68.45,0,0,0,10.47-1.62V69.92a66.11,66.11,0,0,1-10.47,1.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.43,52.91V63.52c0,2.27-3.48,4.54-9.34,6.14V57.6C110.56,56.41,113.86,54.79,115.43,52.91Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.41,49.9a2.94,2.94,0,0,1,0,.51V49.9Zm-58.8,0v.51a1.77,1.77,0,0,1,0-.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 87.19,
    cy: 50.8,
    rx: 23.9,
    ry: 6.55
  })), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 1,
    height: 2,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsSAAALEgHS3X78AAAAEklEQVQIW2MQKZ/4n+n/r58MABdNBRBjFPhqAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    width: 1,
    height: 1,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsSAAALEgHS3X78AAAADUlEQVQIW2P4//8/AwAI/AL+OVLtuwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image-3",
    width: 1,
    height: 2,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsSAAALEgHS3X78AAAAEklEQVQIW2OQnLXrP9O/j+8YABl8BUwJ/mMwAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image-4",
    width: 2,
    height: 2,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGklEQVQIW2OU3XT1PwMDAwPLr5uXGZj4hRgAOswFclaTsn0AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image-5",
    width: 1,
    height: 2,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsSAAALEgHS3X78AAAAEklEQVQIW2Pg9Yj+z/Tn9QsGABPBBIG5WSw/AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image-6",
    width: 2,
    height: 2,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGklEQVQIW2Pk9Yj+z8jLz8Dy5/ULBobXLxgAMogGdMWi0XUAAAAASUVORK5CYII="
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13923",
    "data-name": "Group 13923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13678",
    "data-name": "Group 13678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13661",
    "data-name": "Group 13661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13653",
    "data-name": "Group 13653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6114",
    "data-name": "Path 6114"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 18,
    transform: "translate(88.45 107.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAACXBIWXMAAAsSAAALEgHS3X78AAAAu0lEQVQoU42Su24CQQxFz+JbJB+R/+/zL2kQUkSRKgoiPBcW2ykggt2d1XCqGd8jeR5u3t4/kidRnk+9gq++J1RQ9zmfDIco3WsOsf4BQJfloqLeUeb4frH9Laigy9eSxgzMaGYGJjAjNuuxDJDu4E7tDZX7LbHfVbQrit2mGGR77O2bl1c0LD4Sj1l7RHF47ggAyq4rBsMxAFC2h4J6w+O+thnqFQqk3zo7KLtxuyk0+RM57qiM+tT98welalWVoejIbAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115",
    "data-name": "Path 6115"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 15,
    transform: "translate(99.45 112.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAACXBIWXMAAAsSAAALEgHS3X78AAAApElEQVQoU42SvQ7CMAyEz5Vfg/ffeRcGJhj4U8UALT9R0+QYAhGBpOm3xGefI8uJLJYrYgYcBgCAfoI5jO0BajfrSZN/3BKtv4kc7tzGWN1pnzX5/prNq91ts4USCvqaJ0Fde6x5wNHGWL/FFLyH5ajvLmWT/X8j9X0HiAAiEBFAmqCbkKMxaQNAgAxHvLk8ptI8i8UcmihfX7HSuTD7G3L6874Aco9LeR12gvQAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116",
    "data-name": "Path 6116"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 13,
    transform: "translate(111.45 114.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAsSAAALEgHS3X78AAAAmklEQVQoU4XSPwvCQAyH4VR/g4qLOPv9d7+KOAgOHaRi8Q/aQ+3VJA6FYr1L75mS8E7HZav1VsnAt0twGy+WBL/bRHIblwVBhVMdcXns7fjkeyNtydP19tFsTmgOebw28PVMIDLfwQQ+FakmAPU1iatSXQ/EPYKjvl+RtJVNpgSp7mbQEelGbTzh9zBEG9/NUF8PpHFQTv+If1+Wvj6RCCPX6QAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117",
    "data-name": "Path 6117"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 15,
    transform: "translate(124.45 112.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQoU42RQQrCQAxFfzXoUjyA9997F1e6qCCioOhQxbZpEjdSqJnp9K2Sn7fKLzbbnWEipPVnVJDruZ+pOx5G1CHE5T7n9BBUXSjh4bL5ag3iU+kODhFoFUAQyakAAH3eQXK75LweMm6TR32/BjtpFaKitc1gLxbLtPyPNTVmLmSGMcd8kCXqNulcRhHP8yuObOKfAeALkLpElF/qrVYAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118",
    "data-name": "Path 6118"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 18,
    transform: "translate(135.45 107.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQoU42SQQ6AIAwEl6T6C/9/9y++w5gIJirUUxUQKHNqodl0F8w0L4xOiP2tzYCdBQCQFBrBWVBQhtntb01xU0MEm8q5kKocjk+M4iamZLyZRsjXyA+ELuWW4WIaNdNJGtoD/ZS5kg4AkFzWjMYkaWifithZdVeB/LbCDCP4OrVZPIZ/Zf8jndfGAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6119",
    "data-name": "Path 6119"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(87.45 104.31)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(146.45 104.31)",
    xlinkHref: "#image"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13654",
    "data-name": "Group 13654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6123",
    "data-name": "Path 6123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.61,112.82v12.05c-6-1.56-9.79-3.83-9.79-6.24V108C90.44,110,93.9,111.62,98.61,112.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6124",
    "data-name": "Path 6124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111.1,114.7v12.06a69.5,69.5,0,0,1-11.47-1.63v-12A71.67,71.67,0,0,0,111.1,114.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6125",
    "data-name": "Path 6125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.74,114.67v12.07a90,90,0,0,1-11.61.09V114.76c1.65.09,3.35.13,5.09.13C119.47,114.89,121.65,114.82,123.74,114.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6126",
    "data-name": "Path 6126"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M124.77,114.59A67.28,67.28,0,0,0,135.23,113v12a65.79,65.79,0,0,1-10.46,1.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6127",
    "data-name": "Path 6127"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M145.61,108v10.61c0,2.26-3.47,4.53-9.34,6.13V112.71C140.75,111.52,144.05,109.89,145.61,108Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-2",
    "data-name": "Path 6114-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.61,112.82v12.05c-6-1.56-9.79-3.83-9.79-6.24V108C90.44,110,93.9,111.62,98.61,112.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-2",
    "data-name": "Path 6115-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111.1,114.7v12.07a70.59,70.59,0,0,1-11.47-1.64v-12A71.67,71.67,0,0,0,111.1,114.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-2",
    "data-name": "Path 6116-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.74,114.67v12.07a90,90,0,0,1-11.61.09V114.76c1.65.09,3.35.13,5.09.13C119.47,114.89,121.65,114.82,123.74,114.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-2",
    "data-name": "Path 6117-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M124.77,114.59A67.28,67.28,0,0,0,135.23,113v12a65.79,65.79,0,0,1-10.46,1.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-2",
    "data-name": "Path 6118-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M145.61,108v10.61c0,2.26-3.47,4.53-9.34,6.13V112.71C140.75,111.52,144.05,109.89,145.61,108Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13625",
    "data-name": "Group 13625",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-2",
    "data-name": "Path 6119-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(87.45 104.31)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(146.45 104.31)",
    xlinkHref: "#image"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6122",
    "data-name": "Path 6122",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M146.59,105c-.81-5-13.42-8.86-29.37-8.86S88.66,100,87.84,105a2.84,2.84,0,0,0,0,.51v13.11c0,4.58,9.8,8.36,23.81,9.21,1.91.11,3.81.16,5.61.16,2.4,0,4.79-.08,7.09-.27a67.59,67.59,0,0,0,11.57-1.8c6.95-1.78,10.76-4.37,10.76-7.3V105.52A1.77,1.77,0,0,0,146.59,105Zm-48,19.86c-6-1.56-9.79-3.83-9.79-6.24V108c1.62,1.93,5.08,3.6,9.79,4.8Zm12.5,1.9a70.28,70.28,0,0,1-11.47-1.64v-12a71.51,71.51,0,0,0,11.47,1.62Zm12.63,0a91.64,91.64,0,0,1-11.6.08V114.76c1.64.09,3.34.13,5.08.13,2.25,0,4.43-.07,6.52-.22Zm1-.09V114.59A67.28,67.28,0,0,0,135.23,113v12a65.79,65.79,0,0,1-10.46,1.63Zm20.83-8c0,2.26-3.47,4.53-9.34,6.13V112.71c4.49-1.19,7.79-2.82,9.35-4.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_482",
    "data-name": "Ellipse 482",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("image", {
    width: 65,
    height: 31,
    transform: "translate(89.45 97.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAfCAYAAAC4c6DCAAAACXBIWXMAAAsSAAALEgHS3X78AAAEEklEQVRYR81YPWgVQRCeF1KIiCKigpo0lrGwSGkhYpUilbEQA5aiYJPCxkowIFhLQLFRxCIEIaCIjY2FNqJCWosYTFAEk7z/uxuLvd2b2Z39uUsMfrDM7uzs7My3s3f3XgsR4X/G+PKKN0BEhNXpiZZvPhWt3SKBBrtbPuNQ+6xOn9kREaPjyyu4d0GX2Ov9Ihj5JwQghpsyCreYD9LGXn7dURIjfJgaSOG2grSEwGMciAjsO7b0uTERI6vTEy0nsAJV8xIg6HfjVIscINctcxslOi+UXUFaQ5gHoyopdC0EVdKkNGUFyk3k7TmQCQnfL0/WfkiOmh4WpbRNPDui0wEsCkeXnJhn6J2I+k0He0WOLX4Sj4Np8pplh75oa2SR53JUoguEtavnalWD851w6sXHeM0504kJCdVjNIZcaXupsnyVoTpr184nE1FdB4OEDY1K0qN8alnGhnISXKdUEsFSFaSdnQTxi/Hks/duhJFNMc88AdtIDNY8XyLQD9uSxMotwo/rU0nVIFQCqNeRVQVIT5LCSTyQnTgVZgOzoWVGSSRrnXGM5Qre3w4nHr1N94KFG4SZK0nkykqRDZ21TkwS0SIp7nh9biZaDcEfUCcWXvPwgsHY4zL5wYDPEyHrbAIkHSGM6jy5bNy+EiRCvg4lcDgEFoB0YkOapAf2utT7buAmp2Ir5yiBYj+M6E/p4/efS0cjbCCbhec8eyMADgfVPI2RVgGLPUzGz/mb3mpIJCGwgRFCH6xAaQL9HtT1ZZOBpE8mvLH+ejAnEhG8DgDqPh27+6SKKpEMlSSdRmpZ6tmoMnbUmPylWr3FtB8dm7SXQrQSNI7eeUip50lSSPfdPlEB8ThUUjjoE5VeYyfs1/1+fM+phmglaGC/r74fjAJJ10ogVJ5EOEEDAPZ6RK95Jz5iiVObUodsnYvkSgAAOHJrHs1mkQDQEzh2u5Utm6NrZT3oWbT7QhwA8luoyOHP4gKrhuRKAACegJW4SbPbsVeJXapAdt9RsIujup6EGIkgBDg4NYubr54aImpVAgDA4dk5LPo9cMsLmZB1EiG2zvJb6op+10oOgFaYkzjxZXIkcvvdUnMSAAAOzdzQ3oHJBsFoid22Ox/xZ/vB6Dqua3940wKoeR00sNv2BqeEnCRLQPe89z08Nj+sYii/aDnB3G+jSgAAOHDhklpYOsVOmxsQ5vkDCpkI61HsMiLL51S4itxDUQKh/+1LqzEJAAD7Jy+mL84yqBKtgjBwgld97NjXhCbnk5Z/kaBK1+g6aKgPl3gw7FqYsbLD9lbtu2yk45PIgD2ViNj8OmjsO31WeyuFm3zR3qoWOPvRRImOCGbg1VlOBB0iQra10fyL0YeivQ3Y2Y6ZNcJwcz36h8hu4C/tvDwhRCEwnAAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13664",
    "data-name": "Group 13664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13661-2",
    "data-name": "Group 13661-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13653-2",
    "data-name": "Group 13653-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-3",
    "data-name": "Path 6114-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 18,
    transform: "translate(30.45 102.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAACXBIWXMAAAsSAAALEgHS3X78AAAAq0lEQVQoU42RSw7CMAwFnerBAnEF7r/nLpwAISoqqlLoD7DNIiKkJG06G8fPoyhWzG5/UFoIuK6iA7leggx8PkZUi7QPd842W4IfxJCqdBWcn2ZlH8jQRwdyD3cBF3lE9Xg9bV2tCa6ZQRq7F7gsEuoPKPPkULt21ENu5YTqIUqUGQLJst/WvidIU6c8ByhxsfLbnaFDN6OOyVKCD0hknBhjq4bvg/6HEenLB+d3To41wYcuAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-3",
    "data-name": "Path 6115-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 14,
    transform: "translate(41.45 107.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAACXBIWXMAAAsSAAALEgHS3X78AAAAcklEQVQoU5WSvRJAMBCEv3AlSp33772LNzCjJ0NjEhWD/Bxb5r69nduJ6frB80PitlVjHhJnZ4255O2M+I+Gc/GnhDujGt7zpMHZJfouqQGE2yGTkCoj2lLuriBBK+Fh0GAA2aeRom5wiw4DmLJqf32+A1MeRoKsunnkAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-3",
    "data-name": "Path 6116-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 14,
    transform: "translate(53.45 108.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAACXBIWXMAAAsSAAALEgHS3X78AAAAnUlEQVQoU5XQuwrCMBSA4b/mjCIo6Ob7776Lg0sXESmVCq20tZcch1K1tpr4Lbnwh4QE291e+ZOoepxRO1gKdrjhQ7QsXM2IgMfzPojNUlczIlrfsbfM1Q1M3mTT60TamS2WSBudvga998/SIu9+r01izGr94xi0SfycS3OJAOhHH1KHB1czIlrmADTnoyN9Ccx8o4ExYAxaVa4egAcgUj/ri+XpFgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-3",
    "data-name": "Path 6117-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 14,
    transform: "translate(66.45 107.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAAACXBIWXMAAAsSAAALEgHS3X78AAAAnUlEQVQoU42Ruw6CQBBFDzDxUZvY+f+9v2IsjI2VRgxGQ/CBOzsWBoSscTnVzJ1T3UkWy7UxEKk3q5jTIuZ9L9AiByCbzUPZ7bZBCODKKwBWPwFIRmOkWf6hlwIAcfkhon4RPe5jTovA4OYQPZ9iDngPaYrQqc4edwCSyTTw7VYhvirDQ5Np5wdZivSCH5irP4MDsVe85wYx1ZjT8gZrpUDW/N46+QAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-3",
    "data-name": "Path 6118-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 17,
    transform: "translate(77.45 102.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAARCAYAAAAL4VbbAAAACXBIWXMAAAsSAAALEgHS3X78AAAAq0lEQVQoU42QPQ/CIBRFL+F2c3bz/+/+F0cX42A0bRqbNk3h8RyIrf0Cz8J9cHh5YE7ni+JPqBpiCvk7TEoiU7YWnG1soOJiEAeqG5LyL1TxY6FDn1ABatcmBfVxDMMC/BYptO+gABjedc4dITKdQ9uMmVI+E+ocqp9+AwBCsz8W/eO+e7iEWHTeItQVAIDuds2oE0QIq02pth9t7OGohgUMCVjGlYSUr5X8ASuyTB4VBncwAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-3",
    "data-name": "Path 6119-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(29.45 99.31)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(88.45 99.31)",
    xlinkHref: "#image-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13654-2",
    "data-name": "Group 13654-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6123-2",
    "data-name": "Path 6123-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.59,107.36v12c-6-1.57-9.78-3.84-9.78-6.25V102.55C32.42,104.49,35.89,106.16,40.59,107.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6124-2",
    "data-name": "Path 6124-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.09,109.23V121.3a70.44,70.44,0,0,1-11.47-1.64v-12A72.64,72.64,0,0,0,53.09,109.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6125-2",
    "data-name": "Path 6125-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M65.73,109.2v12.08a90,90,0,0,1-11.61.08V109.29c1.65.1,3.35.14,5.09.14C61.46,109.43,63.64,109.36,65.73,109.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6126-2",
    "data-name": "Path 6126-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M66.76,109.13a68.52,68.52,0,0,0,10.46-1.62v12a66.17,66.17,0,0,1-10.46,1.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6127-2",
    "data-name": "Path 6127-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.6,102.55v10.61c0,2.27-3.48,4.54-9.34,6.14V107.24C82.74,106.05,86,104.43,87.6,102.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-4",
    "data-name": "Path 6114-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.59,107.36v12c-6-1.57-9.78-3.84-9.78-6.25V102.55C32.42,104.49,35.89,106.16,40.59,107.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-4",
    "data-name": "Path 6115-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.09,109.23V121.3a70.44,70.44,0,0,1-11.47-1.64v-12A70.39,70.39,0,0,0,53.09,109.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-4",
    "data-name": "Path 6116-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M65.73,109.2v12.08a90,90,0,0,1-11.61.08V109.29c1.65.1,3.35.14,5.09.14C61.46,109.43,63.64,109.36,65.73,109.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-4",
    "data-name": "Path 6117-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M66.76,109.13a68.52,68.52,0,0,0,10.46-1.62v12a66.17,66.17,0,0,1-10.46,1.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-4",
    "data-name": "Path 6118-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.6,102.55v10.61c0,2.27-3.48,4.54-9.34,6.14V107.24C82.74,106.05,86,104.43,87.6,102.55Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13625-2",
    "data-name": "Group 13625-2",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-4",
    "data-name": "Path 6119-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(29.45 99.31)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(88.45 99.31)",
    xlinkHref: "#image-2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6122-2",
    "data-name": "Path 6122-2",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M88.58,99.54c-.81-5-13.43-8.86-29.37-8.86s-28.57,3.85-29.38,8.86a2.21,2.21,0,0,0,0,.51v13.11c0,4.58,9.79,8.37,23.81,9.21,1.91.12,3.8.17,5.6.17,2.41,0,4.8-.09,7.09-.27a68.55,68.55,0,0,0,11.58-1.8c6.94-1.78,10.76-4.37,10.76-7.3V100.06A2.29,2.29,0,0,0,88.58,99.54Zm-48,19.87c-6-1.57-9.78-3.84-9.78-6.25v-10.6c1.61,1.93,5.08,3.6,9.78,4.8Zm12.5,1.89a70.42,70.42,0,0,1-11.47-1.63v-12a70.54,70.54,0,0,0,11.47,1.61Zm12.64,0a90,90,0,0,1-11.61.08V109.29c1.65.1,3.35.14,5.09.14,2.25,0,4.43-.07,6.52-.23Zm1-.08V109.13a68.52,68.52,0,0,0,10.46-1.62v12a66.17,66.17,0,0,1-10.46,1.64Zm20.83-8c0,2.27-3.48,4.54-9.34,6.13v-12c4.49-1.2,7.79-2.82,9.35-4.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_482-2",
    "data-name": "Ellipse 482-2",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("image", {
    width: 67,
    height: 31,
    transform: "translate(30.45 92.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAfCAYAAAC8hnD/AAAACXBIWXMAAAsSAAALEgHS3X78AAAETElEQVRoQ8VYO8hdRRD+TkhIAoEUihHz/6YVEyEgiDYWKSwTE1EkpWAKLQwBbZUUgliINikipBAMQkhMUiZgYSMqEoiv/obwKyKa/74f57M4r93ZmT177r3qFHdnZ2bn8e3sOXtuRhL/Jz1+8+fkBKxce8cPZ6qiI2WpYLhJp65ZnUScSNjeiSMrA5Jt3viJ/1lxa4lj++ideGolQHauBwh6gzLRKcEkjdbjKCOJzes/pnlbC3BA5+Rz1z6ylkDvpaNLd0f9zNi8fpdFnMREE80aiizIc11u5BNIxCbde/nppQDZWXMEkC+AHTsarZq/UVTkiLAqtrWztONm2Ah2HeS9TTav3hFVBIxKXCyi+jQANX2bAQDmagfdO/1c5+5oOgNA79TRbOPKDwySyCPFRjqilVo6QAeZ2jlR2a4U3DM2vviuBKNtNyNRlZ0KbdxitWLE+qhcaWgS91871qk71EvXxuVv7IcpqUiN3ZrPhUhdqcprraqiN3hyAdr9119IBsQ7JhVxPnMmnsZjuZg3spZG8IniddmVyq6SIDrzbNcucDpFFzKv4wcvfUXKnbUqtgDTyOo4ScJOXTGdeNOwlqJTts6eSuqO6LfJYxdv+dsuC9EKK/013RomGOyYUUR0Xg9p+Wy9/WorIOoxqYgzN+n0hJp1MlF14oiMjSl1tC5nLuUL31fMr6DWr9ZHP74mKgVQFmuuNJOWu6ZbxUDhfOqo6fP1oPO/nz8T7Y5oZwDA1lsnswMffB4C4s4DVso0EHQZZ1N4R83drJrvBkIQy6DWzgCAA+9/Rss51WRLG4Y8J+NGVg+GjwogTWf49/0CYPUpUPz88dE7ZnckgQEAj7x30b97OHzBlnxdrCSRpNS1XunjVDyUFYCVLvvzwrsqIK3HpCJOxuBkgqAaubOuapnLlCEvYrs2onABQO0mOFpWTh06AwAePvchOR4h272nlunHxC3KSN6zB/LRMH2tIiuGlviO7K/LnwTd0QkMAHjojfNNKlpwYyc4GqExkuvl2trCL0rM27+WAVS3aQXIv7/81AMk+ZhUlI9HJecjXRTbzF0q7geUYkExPVUWQPmMcop0iq2PC5t57USJ1bkzAGD/K28y2EUavDP4c4UHxHOGTUeJIuXI0r52pXWoHAH0v75Rd8dSYADA/pNnmsjVE9vcAT0RkMiHA9vW9aW8Few4cT9uzcPvb9dgdD4mFeWjQVLRTbEV0RuCiVNM+KGYQiVok7GSUwjMniee4fjXbzNghc4AgH3Pv8h82BdSd3fKuTOY86jMz5EkOB6aG+AWT1g6f5z0fsmW7gwA8IBw/4uUIwD9KNnJ5YN+qw0TijSfL9I3VuwMANj75LPUAyEM6Iz5YBtVEm5CJl/6o8M7isZsPsOyNa0MBgDsPnS4uaqXY97fdixEDG+qxGfAKHpdRxLz7d9a/7vQaKVjUlE+6Af/OqXQ7MHWUkn/W/QPYWqT3y6Vwu0AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6131",
    "data-name": "Path 6131",
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M36.75,59a.89.89,0,0,1-.59-.23.87.87,0,0,1,0-1.23c.18-.2,4.62-4.9,17.51-5.9a.88.88,0,0,1,.14,1.75c-12.12.94-16.32,5.29-16.37,5.33A.84.84,0,0,1,36.75,59Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6132",
    "data-name": "Path 6132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M130.72,74.24a.88.88,0,0,1-.38-1.18h0a.87.87,0,0,1,1.17-.38h0a.87.87,0,0,1,.39,1.17h0a.88.88,0,0,1-.78.48h0A.93.93,0,0,1,130.72,74.24Zm-3.57-1.39a.88.88,0,0,1-.6-1.08h0a.87.87,0,0,1,1.09-.6h0a.87.87,0,0,1,.59,1.08h0a.88.88,0,0,1-.84.63h0A1,1,0,0,1,127.15,72.85Zm-3.79-.8a.87.87,0,0,1-.74-1h0a.87.87,0,0,1,1-.74h0a.88.88,0,0,1,.74,1h0a.87.87,0,0,1-.87.75h-.12Zm-8.73-1a.87.87,0,0,1,.77-1h0a.88.88,0,0,1,1,.78h0a.88.88,0,0,1-.78,1h-.09A.88.88,0,0,1,114.63,71Zm4.84.68a.87.87,0,0,1-.85-.9h0a.87.87,0,0,1,.9-.84h0a.87.87,0,0,1,.85.9h0a.87.87,0,0,1-.88.84h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13663",
    "data-name": "Group 13663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13661-3",
    "data-name": "Group 13661-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13653-3",
    "data-name": "Group 13653-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-5",
    "data-name": "Path 6114-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 18,
    transform: "translate(22.45 85.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAACXBIWXMAAAsSAAALEgHS3X78AAAAqklEQVQoU42RuQ7CMBBEx2LoqOn4/55/oadAokCECAIkceylIKftTfIaz67fSj7M4XgSrIQiCTfVA0B4/0+ma7UhMcA+SRQiCNdAGqsKYyh2nQgAFFurm1JXk5pSfhU1ht20lJ8FFaAvnktOD6Uu1U15F5Oa/nFX1BhKNdzYv/IZFWBzu84KY4jgLUNcPhyT9nLWzQAi+EGX3RQVMJvdXgy3MCTQri7PkvIP5t1JJLHBoNcAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-5",
    "data-name": "Path 6115-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 14,
    transform: "translate(33.45 91.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAACXBIWXMAAAsSAAALEgHS3X78AAAAc0lEQVQoU5WSsQ6AIAxEH9pRVzf/f/df/AQTZ3QVHAwGFKHeVNo7rlww4zR7lHC7RdxuazzgIgM6QcxRCeC3w3bXEh9y8I8L5dmIkXP/XMlt+b7kBqV3JQ6aAF4r1USJoBRAgBzrQtP11OINMG03qD8fwAlrRUxDmkuqXgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-5",
    "data-name": "Path 6116-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 13,
    transform: "translate(45.45 92.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAsSAAALEgHS3X78AAAAfElEQVQoU5XSuwrDMAxG4RP4X6Pvv/ddOnTJEtoSSgvplTq21S0ZbCxyJiG+Sajb7Q/GxpQ/b88AEC/DMisOfYPW09wfPVMkmwMA6XZ16JriePZMkdJ48kyRLKUmsNej2ClP9wptp/ycPLNmQAdi4z9YCMh+X88VuYeo9QeI/i/JS8639QAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-5",
    "data-name": "Path 6117-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 15,
    transform: "translate(58.45 90.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQoU5WQzQrCMBAGJ+2CIr6C73/3XXryJFikIEr9a6VJ1lPbtGpTBxZ2v8zmsGazzZSZJOo9YdnjgXHWljS77OMHf710vb5qAMxiibTDFO5UACA230fUHmn+kdHZx0Bckccc1DlMmiLqXB8+75jV+uuCv5WIL8+DUEdziKi1Px8BtK66XrR6TKhDJNyMkcSEkME1YrwB/dtcU2+hqXwAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-5",
    "data-name": "Path 6118-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 18,
    transform: "translate(69.45 85.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAACXBIWXMAAAsSAAALEgHS3X78AAAAtElEQVQoU42SS24CMRAFy+TBJsoRuP+eu7DKDUBkmPALHtzNAmk+GTOe2ri7XdJrSw7rzdaZidzHrv3sMyqo+d6CloQPESSQCFqSDruxjDs0EW8ipX2U6go7HgraC1kmDsAup0G/+PxC/4d97Lce1ErVvBUA5H9XYBybQ1ZXby89xrYOqxXqD3L47dqesnP3iBLyx6Pr4v29Cchvl0mhjzBrm0FKBnkhuo9KAtZ9L3lKE+aQJ2kjWWuqog7oAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-5",
    "data-name": "Path 6119-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(21.45 82.31)",
    xlinkHref: "#image-3"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(79.45 82.31)",
    xlinkHref: "#image-4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13654-3",
    "data-name": "Group 13654-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6123-3",
    "data-name": "Path 6123-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32.46,91.09v12c-6-1.56-9.79-3.84-9.79-6.25V86.29C24.29,88.22,27.76,89.89,32.46,91.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6124-3",
    "data-name": "Path 6124-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M45,93V105a70.42,70.42,0,0,1-11.47-1.63V91.35A70.39,70.39,0,0,0,45,93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6125-3",
    "data-name": "Path 6125-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M57.6,92.93V105a90,90,0,0,1-11.61.08V93c1.64.09,3.34.13,5.08.13C53.32,93.16,55.5,93.09,57.6,92.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6126-3",
    "data-name": "Path 6126-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M58.62,92.86a69.69,69.69,0,0,0,10.47-1.61v12a65,65,0,0,1-10.47,1.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6127-3",
    "data-name": "Path 6127-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M79.47,86.29V96.9c0,2.26-3.48,4.53-9.35,6.13V91C74.6,89.78,77.9,88.16,79.47,86.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-6",
    "data-name": "Path 6114-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32.46,91.09v12c-6-1.56-9.79-3.84-9.79-6.25V86.29C24.29,88.22,27.76,89.89,32.46,91.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-6",
    "data-name": "Path 6115-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M45,93V105a70.42,70.42,0,0,1-11.47-1.63V91.35A70.39,70.39,0,0,0,45,93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-6",
    "data-name": "Path 6116-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M57.6,92.93V105a90,90,0,0,1-11.61.08V93c1.64.09,3.34.13,5.08.13C53.32,93.16,55.5,93.09,57.6,92.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-6",
    "data-name": "Path 6117-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M58.62,92.86a69.69,69.69,0,0,0,10.47-1.61v12a65,65,0,0,1-10.47,1.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-6",
    "data-name": "Path 6118-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M79.47,86.29V96.9c0,2.26-3.48,4.53-9.35,6.13V91C74.6,89.78,77.9,88.16,79.47,86.29Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13625-3",
    "data-name": "Group 13625-3",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-6",
    "data-name": "Path 6119-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(21.45 82.31)",
    xlinkHref: "#image-3"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(79.45 82.31)",
    xlinkHref: "#image-4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6122-3",
    "data-name": "Path 6122-3",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M80.45,83.27c-.82-5-13.43-8.86-29.38-8.86S22.51,78.26,21.7,83.27a2.24,2.24,0,0,0-.06.52V96.9c0,4.57,9.8,8.36,23.81,9.2,1.92.12,3.81.17,5.61.17,2.41,0,4.8-.08,7.09-.27a68.59,68.59,0,0,0,11.57-1.8c7-1.78,10.77-4.37,10.77-7.3V83.79A2.28,2.28,0,0,0,80.45,83.27Zm-48,19.87c-6-1.56-9.79-3.84-9.79-6.24V86.29c1.62,1.93,5.09,3.6,9.79,4.8ZM45,105a70.42,70.42,0,0,1-11.47-1.63V91.35A70.39,70.39,0,0,0,45,93Zm12.63,0a88,88,0,0,1-11.6.08V93c1.65.09,3.34.13,5.08.13,2.25,0,4.43-.07,6.52-.23Zm1-.08V92.86a69.69,69.69,0,0,0,10.47-1.61v12a65,65,0,0,1-10.47,1.64Zm20.84-8c0,2.27-3.48,4.54-9.34,6.14V91c4.48-1.2,7.78-2.82,9.35-4.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_482-3",
    "data-name": "Ellipse 482-3",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("image", {
    width: 65,
    height: 31,
    transform: "translate(23.45 76.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAfCAYAAAC4c6DCAAAACXBIWXMAAAsSAAALEgHS3X78AAAETElEQVRYR71YPagdRRT+9vEEEYI/iNEkz1pQrDSlhYiVP9gkpEqwk1eITSoRUiaVhRYqCFoEghhCTCV2IhZJEAIRTPsSY0RU8rg/b+/ufBa7839mZnfvMx/Mzjlnzpk558yZ2b23IokHhWe/+3VfFyOJnbeer0p6JVSpJLgOP7hEBesMXHbn7RfWSsTmfu+OiMlJzNhNnVJARRJbl2+OnFLasYFTDFQbBRI777w4uRo2AHQ7lWtKBY1+I7vgoibMJSvKTbXp1urWAKrF1re/EBOxAfRnKpeEKaBKz6db6wTTtEDT+E0p0Gst2PZN6WbHp8K7GLcu3eiYKG4hEQN02LaRLNAQp/bGBTKpA+D28aOjj8Wmx7U6mxnPaMfl7CdsSwU1puKUkFyyuEQK0SvyyDfXrUBcLCLKEFXT9raCKKimqsPq3jn5yqhqiJNw4SrtBRaglACnSlJjBLrLzFMNbLJyX9aJ4jV/f/fVwYnwjwOA28dfro6c/7mb1XXchVi6tP61TUIn7bSnIQ7T68Q59OZVG/FYBskvxsNf/+h74+wOm0YycRDMqQpBD4RdN0yUwAO4u/3moGqIKkGDzap7dVlJoJBkBHEmUGcT2Kx6wjxkHoC/eaWk5JGsBAA49MX3LDrU29t4w/msQ1zVHh+OW8UCb8jYDzvU8fdOnyhWQzYJz3x6xfei4AxXdRxgCGmOSIfjPn7MResnRXN/fngqm4jkcQCAu9tvVE9/fNGLmHUdK6YuSoFMCiMdZ2dXtSPiYNqtiByylaBx8Oz5spJSyFdMGLTz1qn3Mmc8Q5suTWv1v86+n6yGbCUYmAvLfV0OdJQA62XeeTOUmr/E90RwhOyRCtYJMKgSAOCpjz43q0q75gcaIhgo/qboEQYZDte1HXMvaOOfdrnr//7sjFgNwyoBXZCs9wJh7JyY1NLHleadDgC4twx0XZ1wQ5z5JBmIx0+e5j9fnYsSMbgSAODJD871ifazHy7mZl9yXJc9l/NAV7IbGHi0biDrDPHvhU/WSwIAPPHeGYrlZjpfpkygLhjI6HWSjG3pK9WBeVUHSev7+5e/9BIx+Dho0AuK4HLhZx560TBQRycld7pI7qrsLXrCBseANwbhxghrj64EAHj02HbZqG283fBpa+6t7zjPxaLTDwMzb5BUgELv2vXzzH66YqphdCUA8N/rxazLQXA+c8YkfUunEgUjlm1z/2w98tJrnF/7oQImVgIAHHj9BHOBq/nM0aZIukz6l2nKNgTB5RK+Lzop0nEhlreur5cEoMtmSWcUVvaTPPKr57mYQ06+HKikp8cJoL7zWzXtOGhQCYvovndaONOyfter2W7S4ZJt8v7I2D302CGuVQkA8PBzRznGOTXb7WnzMGOW7h5G4vlIz8zn6XTxfJanQ3LixeiAs105yEgxyfgIA0qAJJrde8X/CoZg7UoAgM0DB1lVeX9W9//YF4f/D/wHUREYoMcC9LwAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13677",
    "data-name": "Group 13677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13661-4",
    "data-name": "Group 13661-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13653-4",
    "data-name": "Group 13653-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-7",
    "data-name": "Path 6114-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 18,
    transform: "translate(79.45 85.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAACXBIWXMAAAsSAAALEgHS3X78AAAAuklEQVQoU42RMW/CMBBGn8WXZOnMxv/f+S/sHVpVFYJGTaAhtnMdADe0jZO3nD7f8+lku812ZyxEZotdhBksvKBJMYbHvBIiBix4nIo/vgX/E4JH5q8H95pD5nsArL/MqCDrviab4wGurNDcROvOqWpoP7PyGFnfpWCnNqOCho9DVrDLdU1XVegecgxNDQ0o7N/m3IT49Rqxnl5L/uV5spnwPRQl4vaDc8T3V9zqaW1OBU6CW4318d8L32bwXOeDwwIuAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-7",
    "data-name": "Path 6115-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 14,
    transform: "translate(90.45 91.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAACXBIWXMAAAsSAAALEgHS3X78AAAAdElEQVQoU5WRsRKAIAiGsVi6bG3r/ffepRdRuzZo0vMSxL4R/w84dMd5MfwEKQUrU8jZYanODUnfjClRik0NpWKGlYaoPWSkTbrrUVQmaQ+9ZuIk6ziNZAkAlWQdpAY5BaAUYfKb+CcSbvY7T8sK9NxWtvACcI5PX9SXB/8AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-7",
    "data-name": "Path 6116-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 13,
    transform: "translate(103.45 92.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAYAAACdKY9CAAAACXBIWXMAAAsSAAALEgHS3X78AAAAoklEQVQoU42RMQ7CMAxFvyXDhLgB99+5CwNLlwpQhUC0tEWkccwQFAJtE95kfz1Zsk2b7U7xJ67vwK7vvkJ7Kmd0D9uySAq/8FDscw50MKHmuEkhlzMAgG11nBS0bUYZrdZgqQ4T+hgVAZobWEVybkDbBuzqa84LqDFgd69znuf9Xkb059TFaLGEDgasz8esBP1MU7EA4JcmosgiIGrVOcS8ACNPS2rZyqGdAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-7",
    "data-name": "Path 6117-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 15,
    transform: "translate(115.45 90.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAACXBIWXMAAAsSAAALEgHS3X78AAAApElEQVQoU42SQQ6CMBBFf5O/0EN4/713YeXKBSYkiCEioDAzLgxIpS2+Vfv6Muli3OGYGf7EVEFT9aQUl0j+gcMpSwYAYM9+PnN5SSFlAQDgmJ+jkbbNylHbBnK7BvIwlKrcamb0XoNS5FvdjImAJvIVgT//Qq2rZGDj6N05Ceu7UA+323tvtO4RDDENGl6eZmxyDK6MpneRJgLn3EI5mPkLueQN7l5VOv1SXBQAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-7",
    "data-name": "Path 6118-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 18,
    transform: "translate(127.45 85.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAACXBIWXMAAAsSAAALEgHS3X78AAAAs0lEQVQoU42SSxKCMBBEO9pcwCqX3n/vXVh5AyxAREQDmXHBx/AJ+lbp5FVPTVXM6Rwr/oCqS0+y6yTvDkewucQAI5g9YUiAhGEElyaj6NIEhCrQWGhjMXS7IsccuiKH3NLFw0IUb0QIqUpQqrIL92JTpsvXx+rrORXnFz7DNACgrGw4R60F1dou1OFmAKA8wkto235FP6xi371YV2FJZDzSD1vt1L76F5wkCX9NqnPBR58PZGZhMXsPFDkAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-7",
    "data-name": "Path 6119-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(78.45 82.31)",
    xlinkHref: "#image-3"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(137.45 82.31)",
    xlinkHref: "#image-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13654-4",
    "data-name": "Group 13654-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6123-4",
    "data-name": "Path 6123-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M90.1,91.09v12c-6-1.56-9.78-3.84-9.78-6.25V86.29C81.93,88.22,85.4,89.89,90.1,91.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6124-4",
    "data-name": "Path 6124-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M102.6,93V105a70.42,70.42,0,0,1-11.47-1.63V91.35A70.39,70.39,0,0,0,102.6,93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6125-4",
    "data-name": "Path 6125-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M115.24,92.93V105a90,90,0,0,1-11.61.08V93c1.65.09,3.34.13,5.08.13C111,93.16,113.15,93.09,115.24,92.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6126-4",
    "data-name": "Path 6126-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M116.27,92.86a69.75,69.75,0,0,0,10.46-1.61v12a65,65,0,0,1-10.46,1.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6127-4",
    "data-name": "Path 6127-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M137.11,86.29V96.9c0,2.26-3.48,4.53-9.34,6.13V91C132.24,89.78,135.55,88.16,137.11,86.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-8",
    "data-name": "Path 6114-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M90.1,91.09v12c-6-1.56-9.78-3.84-9.78-6.25V86.29C81.93,88.22,85.4,89.89,90.1,91.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-8",
    "data-name": "Path 6115-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M102.6,93V105a70.42,70.42,0,0,1-11.47-1.63V91.35A70.39,70.39,0,0,0,102.6,93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-8",
    "data-name": "Path 6116-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M115.24,92.93V105a90,90,0,0,1-11.61.08V93c1.65.09,3.34.13,5.08.13C111,93.16,113.15,93.09,115.24,92.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-8",
    "data-name": "Path 6117-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M116.27,92.86a69.75,69.75,0,0,0,10.46-1.61v12a65,65,0,0,1-10.46,1.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-8",
    "data-name": "Path 6118-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M137.11,86.29V96.9c0,2.26-3.48,4.53-9.34,6.13V91C132.24,89.78,135.55,88.16,137.11,86.29Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13625-4",
    "data-name": "Group 13625-4",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-8",
    "data-name": "Path 6119-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(78.45 82.31)",
    xlinkHref: "#image-3"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(137.45 82.31)",
    xlinkHref: "#image-3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6122-4",
    "data-name": "Path 6122-4",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M138.09,83.27c-.81-5-13.43-8.86-29.38-8.86s-28.56,3.85-29.37,8.86a1.8,1.8,0,0,0,0,.52V96.9c0,4.57,9.79,8.36,23.81,9.2,1.91.12,3.8.17,5.6.17,2.41,0,4.8-.08,7.09-.27a68.7,68.7,0,0,0,11.58-1.8c6.94-1.78,10.76-4.37,10.76-7.3V83.79A2.29,2.29,0,0,0,138.09,83.27Zm-48,19.87c-6-1.56-9.78-3.84-9.78-6.24V86.29c1.61,1.93,5.08,3.6,9.78,4.8ZM102.6,105a70.42,70.42,0,0,1-11.47-1.63V91.35A70.39,70.39,0,0,0,102.6,93Zm12.64,0a88.2,88.2,0,0,1-11.61.08V93c1.65.09,3.35.13,5.08.13,2.26,0,4.44-.07,6.53-.23Zm1-.08V92.86a69.75,69.75,0,0,0,10.46-1.61v12a65,65,0,0,1-10.46,1.64Zm20.83-8c0,2.27-3.48,4.54-9.34,6.14V91c4.48-1.2,7.79-2.82,9.35-4.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_482-4",
    "data-name": "Ellipse 482-4",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("image", {
    width: 66,
    height: 31,
    transform: "translate(80.45 76.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAfCAYAAABTRBvBAAAACXBIWXMAAAsSAAALEgHS3X78AAAEEklEQVRoQ71YPWhUQRD+LkQUm4iIPzGxVhQbJaWVdv4WKlZaaCEpBAsrEVJGGxsLFQQt0ggSYiqxE7HRRlGwTmKMiELiJZd3d28s7u2+3dnZn/cu+hGys7OzuzPfzO7tXYOI8D+x7+WXyhvGfJw7fbARNEhAw7eJ6XDMkY0D26fCtnNnDvVFxmCdDFVGbSIj8+ouK6BBRBid+VxxSSlziUskmlUGEebOHa5dFYMA4hmLjXtRd16BPPePkSP0BX1HjE5/2pgVFSgQhIIZqKeqHE0kKfPnj9SqCuuyHJ3+2Ou4u3NFkg11u46OWVhN0IaJXhsA8xfHKpMxaPW6KkMBz4zMkVi6nrmxeqt9/DYGzsfnyPMPpSIXMlrnbIqm/vl2JZG/+iy9XTkLl49Vqgq7IoDeuSVC+DiEsh4eIwDodgydJSTobV1PVSEpHogPqpGpdz2l6bwJcWOWuW7H62DceakKCr3RxAj4du1EclV4X5Z7n72xvbHMCNTp8CkMxoQ8EnQiyj05UYwgY3Bx/FQSGe7RKECdNsDPqmXg7QjqQLBGIggAOm2jwxNhr2MnUSAnnWN/RQDA8ONXlOIQiB2fgIPUzhyd3fdkVyLV8Y2RWvSXbl2KVkWQiD0PZvmu0UxRO3OD5JCC4ibRNwiDvoBtYlTvx+0rQTK8RwMAFsdPNnbff2FFTVnmGvouT0EMKh0VI1irhKR4ZLMyQghWhMKuySlzBzejUoZZpTh9wMoYsvXAmQ/IuvHLyvzn5A1vVQQrQkNfYOZdUM05ylphGz3k2yPWJ/FLmnr9NgYGnDETSRUBADvvPNK7kkCCHSgHDxbyq1UCJ48PZ1k5Rsq/Ui7J6rW/Hk6IVZFMBADsuHnPNhbmyuvxTBY6o/HpaL1VjqmAdFME7gQNgYhS/v30rkNG2tFQUIwnbew6rG0KHQGg1mppwxz2zeup/IEmrcVQqSIAYPv1CQqxzTfMdaAmKEFHVgMA1I29Zg3oj3FGXNEuzzyxqqJaRQBGBgGAQK01mwyoTaVgSxuRCEF0DNX09bVCKAMk1tcTSGptVK4IABi6MG5UBYRNfbI0RxFnz6G1VXueMZ9nNx50aUeGffPtrK6KWkQAwNDZq1TLoaLNV5soHYQhG/6oO8kgCKLsXyf2Ql19/7oB1DgaCjqQYKAKJIpmx/9t1jdXAoFaLdj+lMRQ0UK35YK1KwIAth49XqaCBygFbGZM7Nu+OL4RuUfGmGffTVJr2ytysoWvjdoVAQCgPLqpfHz8zubNFa/jVdfq/cVtNm0bpr4qAgC27B+juEOl43lzpZD1P08/4andabtVUxN9EwEAm0cP6E+R/M+ybMQDCYGT4gERobOyFP2tIQX9HY0CeXMFiP50B7SXv2+I0/8CfwG5mHrKQdLUXAAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13676",
    "data-name": "Group 13676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13661-5",
    "data-name": "Group 13661-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13653-5",
    "data-name": "Group 13653-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-9",
    "data-name": "Path 6114-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 17,
    transform: "translate(37.45 68.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAARCAYAAAAL4VbbAAAACXBIWXMAAAsSAAALEgHS3X78AAAApUlEQVQoU42SPQ+CMBRFb8NFFmc3///uf3F3MJoQ41ejBPrKczBCkRY4S/PuO71La7a7vWIhVO/nnA4mN16Gc0ZwFAaoBDsRUJ1Lyv9QpYkutK5HGbWqIuoXdf0FkxdgGMTQ6t2dbO1zUg6hNvFmfdlRxvZ2iag9vzKzKtLNIa19AAAo5XlG7SEmmv39Opjpjoe4GSIOYA5Clj23L08w2Xqz+D9/AGv+TQEHa5pgAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-9",
    "data-name": "Path 6115-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 14,
    transform: "translate(48.45 73.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAACXBIWXMAAAsSAAALEgHS3X78AAAAp0lEQVQoU42Quw6CQBBFz7pjZ23n//f+i42NnUZAjDFRcB9jISBGFjjNnb1zJ5sZs9nulJlojIiGMJX7oBEAaYs5qHOI1vV4yLuuNrJE+kYKratORZ+P4VA17Eso88FGCkFnXxUACdlxKoO+voeR/mOMcL0AID47JUPxfvvzxB/2YAWsxVgLi0YbLxbn3wFVBe/AO9r1Q57+1djVWo0Ixgr0NJTF4MAbh4RO+AmE3UMAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-9",
    "data-name": "Path 6116-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 13,
    transform: "translate(60.45 74.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAsSAAALEgHS3X78AAAAkElEQVQoU5WQsQoCMQyGU/u7iTi5+f677+LmoCicUNBDFIU2iYOHWtpe8FtCki8kxK3WG6U/geowIzJu/oCmnGK9jilBn496s0VKBBK2tA8yLIDcb4ZaAj4HyynIzpP+MqJ+AYeT5RQgHneWUwBi+3scuixH3G8b6hu59lk+mS/I+dlSHUDkQc77akzdIRt8AYR7NF4cPQuuAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-9",
    "data-name": "Path 6117-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 15,
    transform: "translate(73.45 72.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAACXBIWXMAAAsSAAALEgHS3X78AAAAs0lEQVQoU42SvQ7CMAyEL44nQLwB77/zLLAwIQRIlahUtZRSmtgM9EdtAvSbnLuLnUQxm+1eMRNWnZ0FN4fdv0wP66v+avpbMlqzOx/jSQDyKPuaFkuwu54AsoAlGLJtbWGIALKQLP1szFKwigAigAO6q8o9D6bQag32ySUwpqgItCzazjOQIgd3Z5oDq3NRQ+sq0Fir4XlGTJswg/UZdojiGlAg/vgrrN7DGDMoxkC9j4bfZBBPp1hh8T0AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-9",
    "data-name": "Path 6118-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 17,
    transform: "translate(84.45 68.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAARCAYAAAAL4VbbAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQoU41SOQ6AMAxzIQNIzGz8f+cv/KQHU8JCRemVemoVy7WdmuO8BIMg9lbjQLwDAFA8aGDvQDxAlvd1ko6NXEhVlvDNKb2kqAXvtpGHr7bRstb0XAtetNELXFVuLarwzKEdmOJwZO0/Ze1TEXs7pAoAZt52mZYVfAeNiwdzF15csCKRnwAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-9",
    "data-name": "Path 6119-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(36.45 65.31)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(95.45 65.31)",
    xlinkHref: "#image-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13654-5",
    "data-name": "Group 13654-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6123-5",
    "data-name": "Path 6123-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47.58,73.14v12c-6-1.56-9.79-3.83-9.79-6.24V68.33C39.41,70.26,42.88,71.93,47.58,73.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6124-5",
    "data-name": "Path 6124-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M60.08,75V87.08a70.44,70.44,0,0,1-11.47-1.64v-12A71.51,71.51,0,0,0,60.08,75Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6125-5",
    "data-name": "Path 6125-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M72.72,75V87.06a91.81,91.81,0,0,1-11.61.08V75.07c1.64.09,3.34.13,5.08.13C68.44,75.21,70.62,75.13,72.72,75Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6126-5",
    "data-name": "Path 6126-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M73.74,74.9a67.22,67.22,0,0,0,10.47-1.61v12A66.09,66.09,0,0,1,73.74,87Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6127-5",
    "data-name": "Path 6127-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M94.59,68.33V78.94c0,2.26-3.48,4.54-9.35,6.13V73C89.72,71.83,93,70.2,94.59,68.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-10",
    "data-name": "Path 6114-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47.58,73.14v12c-6-1.56-9.79-3.83-9.79-6.24V68.33C39.41,70.26,42.88,71.93,47.58,73.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-10",
    "data-name": "Path 6115-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M60.08,75V87.08a70.44,70.44,0,0,1-11.47-1.64v-12A71.51,71.51,0,0,0,60.08,75Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-10",
    "data-name": "Path 6116-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M72.72,75V87.06a91.81,91.81,0,0,1-11.61.08V75.07c1.64.09,3.34.13,5.08.13C68.44,75.21,70.62,75.13,72.72,75Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-10",
    "data-name": "Path 6117-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M73.74,74.91a68.45,68.45,0,0,0,10.47-1.62v12A67.28,67.28,0,0,1,73.74,87Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-10",
    "data-name": "Path 6118-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M94.59,68.33V78.94c0,2.26-3.48,4.54-9.35,6.13V73C89.72,71.83,93,70.2,94.59,68.33Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13625-5",
    "data-name": "Group 13625-5",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-10",
    "data-name": "Path 6119-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(36.45 65.31)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(95.45 65.31)",
    xlinkHref: "#image-2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6122-5",
    "data-name": "Path 6122-5",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M95.57,65.32c-.82-5-13.43-8.86-29.38-8.86s-28.56,3.85-29.37,8.86a2.22,2.22,0,0,0-.06.51V78.94c0,4.58,9.8,8.36,23.81,9.21,1.92.11,3.81.16,5.61.16,2.41,0,4.8-.08,7.09-.26a68.61,68.61,0,0,0,11.57-1.81c7-1.78,10.77-4.37,10.77-7.3V65.84A2.24,2.24,0,0,0,95.57,65.32Zm-48,19.86c-6-1.56-9.79-3.83-9.79-6.24V68.33c1.62,1.94,5.09,3.6,9.79,4.8Zm12.5,1.9a70.44,70.44,0,0,1-11.47-1.64v-12A71.51,71.51,0,0,0,60.08,75Zm12.63,0a91.64,91.64,0,0,1-11.6.08V75.07c1.65.09,3.34.13,5.08.13,2.25,0,4.43-.07,6.52-.22Zm1-.09V74.91a68.45,68.45,0,0,0,10.47-1.62v12A66.09,66.09,0,0,1,73.74,87Zm20.84-8c0,2.26-3.48,4.54-9.34,6.13V73c4.48-1.19,7.78-2.82,9.35-4.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_482-5",
    "data-name": "Ellipse 482-5",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("image", {
    width: 65,
    height: 31,
    transform: "translate(38.45 58.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAfCAYAAAC4c6DCAAAACXBIWXMAAAsSAAALEgHS3X78AAAEHElEQVRYR8VYTYsdRRQ9DbMxGEQwhBDHPxAFFwpm4ULQhRsHs5EENyLqUhBEyM6VgiAogjtdBIwrSRQEwYUQFyouBL9+wIySiKA4zvvq995x0R+v7ld3db9Rz2Kq6tatuveeOtX9egqS+L9xzyc/ZSXh5br/xLnCcR2EYggJabJD1m0HFccJu79371ZEFLsf/8j/rKBji+MoYu++0UTsHCsBZq+MvTNc/m0UJLF7/Ye8VI6TsBBOjHUeufsX7h+lhp2qoWicQYxMtw28ItfW1iAgXqY6OAmB9sG4e+17+wRy9w4CGvPGwLTI3oS9Awl8VBcADp56cLAaxNth96PvbGiajnVZrcI5CctzJ/oIY0pu+wcHl84PImInHYQnZuTqJDfmKmlojtYr+IoMbEkzBOZ3wt0ffjNimxrNyWSoBwC4XKYjpxspx7NL2y/PPJKtBkvC1a8qg7NxC9KZcU5nWRovT+IM7P6J1/akMYO6++tzj2URIa4DABxcfKg4e+VLGSUIJk8ymcvVUtdboQNcNXE1SRFp3Qh/Np99/wsCrAJGjHeaO7Kh6cjpRkHaj8JY2+RY13PzxSd71WCU0IBayu3mWnZ+UoleLIllab89vF+bLgkd47bbcQAOOj+gzrz7Kd0iepLhYiH9U3iJC1O3nSOu0K1XLnWqofcr8szb1+wHFgmUaaHJVNMJk41I8SAnWZaIDyFQRz3326vPh0SE16EBy4X/KtPqELZkMjp579RJsCE3vVbpIaTXspcML1eLXiUAwOnXrqQZVUaV2GakklOJcj7LTx6Qe4tcu+N4uf7+5suuGnqVAACcz9GXcNUluKh903wFKBqBlX7l5oPlwi3cPqgtspQAAKcuv0MQ4GJWGcxzov1jEMeIyLJEcTFPYjbr1GEoEtrlybo/3nvdqCGbBAC466U3pDMpC4zuq+mr5AGsZ1NJ7KCCqz901yl/An9efUsQkXUdGnAuVRAGdQrgbKrm9Hq9tvYQ04oIoP8LdrnEZp2KVWOQEgDgzmcv0yuYs4l0dJKv3vG6MA2KJpyvu1w0D1raFkB7LdQz4vCzD1o1DFICAHA2rR9CPSfGpN82soBoLj0YziZhcbrdhAx8kj1uf3iPf9+4XgAjlAAAd1x4gVFS7AjsFbOeHGX7DoqRzmui6vHk28/HkwAAJx9/mjmMrydHypZC22i65hsmE9Xzq4PUOtfpz18Xg69DA06OIIrsux5J49ssAda2Ga+nE+QUKVXj+GELJQDAiQcebSIhCqBVkiVlAuujw8TP30vK298HCSHRuq1IAIDbzp13r0V3cqyKbEMnc23j9YOf0JrQ1RJD6hp9HRpsipHFVieZFpKCbtc40nTUnF8oSSwPb/X+M6XB1koAgJ2Tp1kU2TEFyr9ujlt4jPgHPDaMG/ikm+IAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13738",
    "data-name": "Group 13738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13661-6",
    "data-name": "Group 13661-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13653-6",
    "data-name": "Group 13653-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-11",
    "data-name": "Path 6114-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 18,
    transform: "translate(92.45 70.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAACXBIWXMAAAsSAAALEgHS3X78AAAAqklEQVQoU4WRUQ6CMAyGvyW9hvd/9y5eQBNJMBgRVMDR+jCGYmD7X9q1X5u2c7v9wchImxrRpgZgvF6SsPjzcTOpr+cX/H2sSW9VAMfilAQBbOgRG/o5EOddk/iy2EwC4N8BjE5K+miRsSqTkKkCINGZExtXkLh+ToJlfxAA0faeYwCQtaB5P/tOAiLWdeAcOILFBTvBsUjAwAwyowqL80ydgf8lxRaB7c4fLihXc+5OtjQAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-11",
    "data-name": "Path 6115-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 15,
    transform: "translate(102.45 75.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPCAYAAAA/I0V3AAAACXBIWXMAAAsSAAALEgHS3X78AAAAc0lEQVQoU5WRMQ6AIBAEl+Raehv/3/sXHyKQaHVrBVECHEx1hB02Odx+nMQios9tZQpMAQAgeZhFU4DogpSz05KmWGb5HnrUD5tNrfuh1FtSc3tWe7dpJDal5SZLACppRgAAJ36j8x6M9n9lhFQwXFbuxwvYLFJPSl5rLgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-11",
    "data-name": "Path 6116-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 14,
    transform: "translate(115.45 76.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAACXBIWXMAAAsSAAALEgHS3X78AAAAp0lEQVQoU5WPwQ6CMBBEB3Z/woP/f/db9KIXEjWYQCAmiEDbXQ/ECikVfZfOzsym2WS7Oyj+gFXnfZefgxJttl6zOe6DwhR5NLC3q5/ZZCcgJSREANFE8/imBFfknwWIACJQa7wZO8rVJdhcskgcokMP1qGH3Ku1roelLgNT2mahOsKuKqKhxzkveTp8Q7oWAMCx79XaRZ+1ey4GMdK1wgwRsP54w5sXbldKYdw7/foAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-11",
    "data-name": "Path 6117-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 14,
    transform: "translate(128.45 75.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAAACXBIWXMAAAsSAAALEgHS3X78AAAApUlEQVQoU4WQwQrCQAxEZ7fjSQVB8Ob/3/0Xv0CsFBRFW6vQJF5qu+1u9R0CSSZDErfd7Q0JTHWQO+9BEwkqXWgneh8TARFiXUhCe9WTzTGEBmsE6Ds2oVZlQpqGcrv803QQoxcBgFaPqObnS1CKY9RIIeUdtIkDv+i1X5NNfvghHUKrn8mGnIuoxuaUdtbRl/xqDZctNuY4gyMBEi4j0OZNkQ8GPpb7QEn6n9p+AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-11",
    "data-name": "Path 6118-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 18,
    transform: "translate(139.45 70.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQoU41QMRKDMAxT7jz16MzU/+/9Cy+BBLpYHXoBkzoGTUmsSJbS6z0RNyD8bFccAIBoySGBZfkR6yGClhwrcj1mYi8etFprx5qNk7QPFlbEVfQ+dxXbkG5qr7JTjxo0IO2wt8q+Y6+mnWgJUVXCkv8SekjyHJkeg5vUQkiCeQ5JAPAFDR5hZSvpqU8AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-11",
    "data-name": "Path 6119-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(91.45 67.31)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(149.45 67.31)",
    xlinkHref: "#image-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13654-6",
    "data-name": "Group 13654-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6123-6",
    "data-name": "Path 6123-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M102.31,75.45v12c-6-1.57-9.79-3.84-9.79-6.25V70.64C94.14,72.58,97.61,74.24,102.31,75.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6124-6",
    "data-name": "Path 6124-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M114.81,77.32V89.39a70.56,70.56,0,0,1-11.48-1.64v-12A72.76,72.76,0,0,0,114.81,77.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6125-6",
    "data-name": "Path 6125-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M127.44,77.29V89.37a89.81,89.81,0,0,1-11.6.08V77.38c1.64.1,3.34.14,5.08.14C123.17,77.52,125.35,77.45,127.44,77.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6126-6",
    "data-name": "Path 6126-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M128.47,77.22a68.32,68.32,0,0,0,10.46-1.62V87.65a65.81,65.81,0,0,1-10.46,1.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6127-6",
    "data-name": "Path 6127-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M149.31,70.64V81.25c0,2.26-3.47,4.54-9.34,6.13v-12C144.45,74.14,147.75,72.52,149.31,70.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-12",
    "data-name": "Path 6114-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M102.31,75.45v12c-6-1.57-9.79-3.84-9.79-6.25V70.64C94.14,72.58,97.61,74.24,102.31,75.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-12",
    "data-name": "Path 6115-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M114.81,77.32V89.39a70.56,70.56,0,0,1-11.48-1.64v-12A72.76,72.76,0,0,0,114.81,77.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-12",
    "data-name": "Path 6116-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M127.44,77.29V89.37a89.81,89.81,0,0,1-11.6.08V77.38c1.64.1,3.34.14,5.08.14C123.17,77.52,125.35,77.45,127.44,77.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-12",
    "data-name": "Path 6117-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M128.47,77.22a68.32,68.32,0,0,0,10.46-1.62V87.65a65.81,65.81,0,0,1-10.46,1.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-12",
    "data-name": "Path 6118-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M149.31,70.64V81.25c0,2.26-3.47,4.54-9.34,6.13v-12C144.45,74.14,147.75,72.52,149.31,70.64Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13625-6",
    "data-name": "Group 13625-6",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-12",
    "data-name": "Path 6119-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(91.45 67.31)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(149.45 67.31)",
    xlinkHref: "#image-2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6122-6",
    "data-name": "Path 6122-6",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M150.29,67.63c-.81-5-13.42-8.86-29.37-8.86s-28.56,3.85-29.38,8.86a2.94,2.94,0,0,0-.05.51V81.25c0,4.58,9.8,8.37,23.81,9.21,1.92.12,3.81.16,5.61.16,2.4,0,4.79-.08,7.09-.26a68.59,68.59,0,0,0,11.57-1.8c7-1.78,10.76-4.38,10.76-7.3V68.15A1.8,1.8,0,0,0,150.29,67.63Zm-48,19.87c-6-1.57-9.79-3.84-9.79-6.25V70.64c1.62,1.94,5.09,3.6,9.79,4.8Zm12.5,1.89a71.37,71.37,0,0,1-11.47-1.63V75.71a70.39,70.39,0,0,0,11.47,1.61Zm12.63,0a89.81,89.81,0,0,1-11.6.08V77.38c1.64.1,3.34.14,5.08.14,2.25,0,4.43-.07,6.52-.23Zm1-.08V77.22a68.64,68.64,0,0,0,10.47-1.62V87.65a66.11,66.11,0,0,1-10.47,1.64Zm20.84-8c0,2.26-3.48,4.54-9.35,6.13v-12c4.49-1.2,7.79-2.82,9.35-4.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_482-6",
    "data-name": "Ellipse 482-6",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("image", {
    width: 65,
    height: 31,
    transform: "translate(93.45 60.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAfCAYAAAC4c6DCAAAACXBIWXMAAAsSAAALEgHS3X78AAAEEElEQVRYR81YPahURxT+NkgwEBAJKkafICkTRMRSG0mTFFZqZToLMZDGJoVVIIK1IoIhVQgWEpJYhGCTxsJKULFN8fxFIpj3dvft2937Wdw7954zc+bn7nuKH+w7M2dmzt98c+/cNyCJ9xn7bj2KBkgSy8c/H8TGSzHYrCLIYDfLZh61n+XjX2yoEFv23XrEdxd0g3ftL4MP3koByPSvnpT+5WyI39LvDzaUxBbd9WxFTRsDGwqjEKwMXajqiwFJLP3xUJtKsmMBr6VLWIm5mUUM5yyfOLTQs6F9MNaU6rvDiUFrqJonptjuNaiEhcenDvcuRHccHNUCBxGPxo6xcnQVa0oTi3SjA1m75VCvyKWb98ztaDVzvZNFiB6tHlnM53ZUpgniyekjvdigHoys5oC1mxbUcGFCBnsAgG1xLbpbrIqxojAOD8Flae+Nu4LfQUN0DYekHcZsKua0fzQMxjCit1mgC/j0zJfFbDBvjHt+uRNmnXHK+SwSsA9rtz1UxqvQgnzQNr7lDj47+3VRIbx7QoP5LGABZzNzaph4IrtYIROgY5HPSp9RQT9v2yH67fDp9dvlVtr3u7Ek2KGm5xSzabA2iMkqtFmUsP/8/MksG+JFuPaXH5qXidFXC5rk19cTcyydGLQKK3TdEoaFavvEi+9PJwthHwcAT89+Ndh9+U+dqV8WEpjKJCPw15We+RbhRnHqHrYyxFg7jeyn9K5Lv1pbYTiwp6XHIr4JcLrejcsYRVvHni7Gy4vfRtkQZYJGwkErjDa8QGUCkzX0smW06TqJ5MWCKLJMAICdP/zceS8sRp2kHGbXbPWWb3qTGl3hbbV7izk7LjbivysXTDYUFQEAdly4Km5C1ElKWOddBhNBPo46Ka5PhMqt8ROO61799GNQiMLjAHA0FB0dcNnZNMaEcA2urYkxg/K5xOWcRke1LkQxEwDgk+8usnWWCYCRwDked3PVmFxr6+FG6beNOAD7LVTN8frmNcWGYiYA0Al4ibdpjkf+KrMpFVTnnca8PLrjKQoTkx56MQEAtn9zntVkDSG9qIStswri6zy7ja6ajL1kAMmwVMJtjkKu/vNby4beRQCAbSfPOetQcoFgnOR4GI5n7Pl2mF2ndcO7fw+AnsfBgeNhNLha2EmqBFwret7TfcrP8xSaG60usLa7EBMA4ONjJ+qFjVH19gC6YCvvvAtRrFdNPck9p9IsCjelFsTk3/uDhZgAABwNxWeu71i2ZYJhEC0iNjjyj4lMLiY9+2aB6vaHO/dzYSYAwEcHjrIkGHUs2n6zdLjS+yy3MrApZGK+lCQXPw4OWz876Kw1QidfDVe6yYEvKlGu8+zIJBM6kpitvFj8xhhDNVwFR6u5ab0x/f959p8hm4U3GcmzMgxJEJEAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13737",
    "data-name": "Group 13737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13661-7",
    "data-name": "Group 13661-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13653-7",
    "data-name": "Group 13653-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-13",
    "data-name": "Path 6114-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 18,
    transform: "translate(58.45 52.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAACXBIWXMAAAsSAAALEgHS3X78AAAApklEQVQoU4WRMQ7CMAxFXyJfg/vv3IUNIQFSB1CBidI0sRmqFijgvMn6eoPtH1brjeGgjw4AmQYPvZyRvN+6kg0DADINHnprkXzc1TwAxFRrDgCSm0PNAUAw9zszUk5NzQFAfoXa3b8yKdcWYiSECDFCDBAitihCMIWieJtaSoilhKXe0UbE+j9dl/IpLoN3LOeXaEP6K84YyHyF+VWKaSGEMLpOS09nNVG1aHQ0eAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-13",
    "data-name": "Path 6115-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 15,
    transform: "translate(68.45 57.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPCAYAAAA/I0V3AAAACXBIWXMAAAsSAAALEgHS3X78AAAAdElEQVQoU5WSsQ6AMAhEW6WbcXTz/3f/xR9BtibgVKOWFnpjuXeXQON+nBIGBZKz5akETGh5PmLCMah43ZC8fCAO6B/cbWK61HdoDYq0UKNJnzWhXpgKWcuptuc5wdPkMRcBEwYmDNOyusE4L5vElMLIx70Baf5SWXnc6OsAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-13",
    "data-name": "Path 6116-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 13,
    transform: "translate(81.45 59.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAsSAAALEgHS3X78AAAAn0lEQVQoU5WSuw7CMAxFrxsjlrKy8f87/8LCghiqCkW8FIZWqWOGCKqStilncWwfS5Yc2u0Pij9hFck5CQwNs4J6n9RY23ZEjahPe7Rag4N7jugTaIA2TX69X4J7gOV+zXkJLJcq5yQwdHgmudkJtYd9dZ4V9OUGOZUbsD8dQYUBjAGZGFF83gwqDDpb91O2juupdIB0WPqfyJTbpe6XN16gPiuejhgBAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-13",
    "data-name": "Path 6117-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 15,
    transform: "translate(94.45 57.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAACXBIWXMAAAsSAAALEgHS3X78AAAAk0lEQVQoU42RzQrCMBCEpzrQm/gCvv/dd/HgRQVFqFj8RZqm2fUWtNmQfrfMfCy7pFqtN4qJUD5vswjNOck4HPeGCoTn/e89XyxBv9ua8hi5NpiVpF/oT4eSEyEGny1ltDdDe8moKQy3tuRECJUkVOeSrKprUF6PpEhQhfYdCJ322+p7UF1X8iJEbrBxC1WCYdp8AVVpO7ucw7nKAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-13",
    "data-name": "Path 6118-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 18,
    transform: "translate(105.45 52.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAACXBIWXMAAAsSAAALEgHS3X78AAAAu0lEQVQoU4WSywrCMBBFT+JsdCXu/f+9/+JOEOmioFIUodWYZFxo05dtLwzc3DmbzIzZ7vbKhOKzAkBqM6VYXBB/OkxC+nYASG1qhVuR/GK9SZn47MiY/OOevGgIo2Bb4vNsjgFA0DjHACDhnM8xAMi/MFZl522XKyQUV7AWYy0YC/Zb2oJDVSKgEAMam9+r684WQNQ51L0GjSH4Gtl1b77SD9pS7xuwv+uG6l6fpEAnzxLRGDHG/Nhx+APW9F2OFVIFRAAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-13",
    "data-name": "Path 6119-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(57.45 49.31)",
    xlinkHref: "#image-5"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(115.45 49.31)",
    xlinkHref: "#image-6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13654-7",
    "data-name": "Group 13654-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6123-7",
    "data-name": "Path 6123-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M68.42,57.72v12c-6-1.57-9.78-3.84-9.78-6.25V52.91C60.25,54.85,63.72,56.52,68.42,57.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6124-7",
    "data-name": "Path 6124-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M80.92,59.59V71.66A70.44,70.44,0,0,1,69.45,70V58A72.64,72.64,0,0,0,80.92,59.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6125-7",
    "data-name": "Path 6125-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M93.56,59.56V71.64A90,90,0,0,1,82,71.72V59.65c1.65.1,3.34.14,5.08.14C89.28,59.79,91.47,59.72,93.56,59.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6126-7",
    "data-name": "Path 6126-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M94.58,59.49a68.45,68.45,0,0,0,10.47-1.62V69.92a66.11,66.11,0,0,1-10.47,1.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6127-7",
    "data-name": "Path 6127-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M115.43,52.91V63.52c0,2.27-3.48,4.54-9.34,6.14V57.6C110.56,56.41,113.86,54.79,115.43,52.91Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6114-14",
    "data-name": "Path 6114-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M68.42,57.72v12c-6-1.57-9.78-3.84-9.78-6.25V52.91C60.25,54.85,63.72,56.52,68.42,57.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6115-14",
    "data-name": "Path 6115-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M80.92,59.59V71.66A70.44,70.44,0,0,1,69.45,70V58A70.39,70.39,0,0,0,80.92,59.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6116-14",
    "data-name": "Path 6116-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M93.56,59.56V71.64A90,90,0,0,1,82,71.72V59.65c1.65.1,3.34.14,5.08.14C89.28,59.79,91.47,59.72,93.56,59.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6117-14",
    "data-name": "Path 6117-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M94.58,59.49a68.45,68.45,0,0,0,10.47-1.62V69.92a66.11,66.11,0,0,1-10.47,1.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6118-14",
    "data-name": "Path 6118-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M115.43,52.91V63.52c0,2.27-3.48,4.54-9.34,6.14V57.6C110.56,56.41,113.86,54.79,115.43,52.91Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13625-7",
    "data-name": "Group 13625-7",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6119-14",
    "data-name": "Path 6119-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(57.45 49.31)",
    xlinkHref: "#image-5"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(115.45 49.31)",
    xlinkHref: "#image-6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6122-7",
    "data-name": "Path 6122-7",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M116.41,49.9C115.59,44.89,103,41,87,41S58.47,44.89,57.66,49.9a1.8,1.8,0,0,0,0,.52v13.1c0,4.58,9.79,8.37,23.8,9.21,1.92.12,3.81.17,5.61.17,2.41,0,4.8-.09,7.09-.27a68.43,68.43,0,0,0,11.57-1.8c6.95-1.78,10.77-4.37,10.77-7.3V50.42A3.05,3.05,0,0,0,116.41,49.9Zm-48,19.87c-6-1.57-9.78-3.84-9.78-6.25V52.92c1.61,1.93,5.08,3.6,9.78,4.8Zm12.5,1.89A70.42,70.42,0,0,1,69.45,70V58a70.39,70.39,0,0,0,11.47,1.61Zm12.64,0A90,90,0,0,1,82,71.72V59.65c1.65.1,3.34.14,5.08.14,2.25,0,4.44-.07,6.53-.23Zm1-.08V59.49a69.69,69.69,0,0,0,10.47-1.61v12a66.11,66.11,0,0,1-10.47,1.64Zm20.84-8c0,2.27-3.48,4.54-9.34,6.13v-12c4.48-1.2,7.78-2.82,9.35-4.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_482-7",
    "data-name": "Ellipse 482-7",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("image", {
    width: 65,
    height: 32,
    transform: "translate(59.45 42.31)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAgCAYAAABNXxW6AAAACXBIWXMAAAsSAAALEgHS3X78AAAEQUlEQVRoQ9VYPahdRRD+DrwiBoKI/9GX0kK0CKSyEkSwEQORWKRRUojYaKNYpJE0goUKAdEmCIIkBI0BG7E1kEJBEysrn4aoqOjj3nd/z2dxfnZ2d2Z3z7km4FfcnZ2Z3Z35Zs6e815FEv9HHLr0AwHgp6cfrnK+OWzlHDZFF+wY3KoCVd1BMthbdTgQnDPy2J1nHtmoG6rtz6/xpiU9at/MGsO8c/TR0URslRFgVaxgbYHLxmCd80iiIonti1ftUItI6jDE1wChJ1VA/M6xw6O6oSHhs+/bnRNJZPPLOvgurNt5vC7SZAvhwv/5+JHBRGwBzfO0/el34iTjUE+dJoz1OmE0TJ1dEU0fZToUlbwTti98q2+nVIx1Hel8B9vU2HMOBiS5bVzhTr+ceGxQN3jfCU1iAEBgrV02BYGrLgXrWnC9agVPq4gZ3QBU4dvhwU+uGN3QqRWz0inOFlRqteoMgV8kiGnQhYDRSexdr598orgbIhIA4IGPv46VmUN7rJaal7He80gUsjXUiT26N4og7fqLTxURoX82r1dmZdhXMrZ5Kou0UoQNsV4GOlmAkMQB58DoBAA4+OGXw3bSoL0hRKW8A5ZdBwltEFsUaxR7TMyNV5/NdoP9B5TSXnLuNPTM6hwAFwvDx6iiVlWDBOeaI0mH2QkAcP+ZS9SDCecElzJJAW29BiLxbZGAvIPkJSzy+u3UC8luSJIAAPe9c4Eg/CS1NlREUxn5KIu6hlguxAS6DHgx+TkRIPD76ZdMIrL/T+B8bhhqEQO9wQ4U8F6YJLjo9qe/3pL7QZMpvJR1BrKdAAD3nD7b7hsznJM5n3lLooDC51rohCJ0cEPhI8TVCn+894baDUUk3H3qfeEUJikqKRFumwq2sGIdSALLhU+g/JiLCuJI+/ODNyMiikgAgLtef5fw7oX+x6mGVFCduwnnsyAB50Qt4Ugn93Z7/PXR2+NJAIA7X3mLWcYTAbAdAYCzqb5eWdcMIs5cDP0Q6poY/j53xiMiezFKuMBTBzU/9WxP2EJoekZi/8fUELQXbU9aMFa37Y+WDOoEALjj+deaV+Zs2uuaPUYk7OljEjQ953ut7HeWV4xEcbpx96vzfTcMJgEAbj/+svJYyGTDAIJAAPO55t40Wm9V1U7YH62zJpe/qICBj0MHzlw1vDFRDbZ+nE7ggoWTxT4UMkJZJdvJxY+QuORHdQIAHHjyOUYktC3aJNoh2L9zVYOlN5h2xYfeHURHaKZQsx+/qUZ1AgDU04n4EEpUpx8UGQCCIuhvAQAgOA0elfBeIAO78+vszt/FOboTAGD/4cebxdYzaAYVjm0HTXYzAacTbIZh/iA3IwEA9j10hCWHkWySbM3tjzf3Igm6IDB6gznvRXtOctzFKMHJbruvSDIFLdBCkMRq99fsP0mGYuNOAICtA/eyqiqgqrwKLv+58Z8HfDPwL2FRlwS2l7oBAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13788",
    "data-name": "Group 13788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6147",
    "data-name": "Path 6147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M23.32,74.15h-.25c0-5.8-3.44-10.53-7.66-10.53v-.24c4.23,0,7.66-4.73,7.66-10.54h.25c0,5.81,3.44,10.54,7.67,10.54v.24C26.75,63.62,23.32,68.35,23.32,74.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6148",
    "data-name": "Path 6148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M152.33,107.15h-.24c0-5.8-3.44-10.53-7.67-10.53v-.24c4.23,0,7.67-4.73,7.67-10.54h.24c0,5.81,3.44,10.54,7.67,10.54v.24C155.77,96.62,152.33,101.35,152.33,107.15Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17696",
    "data-name": "Rectangle 17696"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88,0h0a88,88,0,0,1,88,88h0a88,88,0,0,1-88,88h0A88,88,0,0,1,0,88H0A88,88,0,0,1,88,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/Rewards.eb1d6c8de5a6954b6fcb74bc9ba4635c.svg";
export { ForwardRef as ReactComponent };